import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import {
  institutionApplicantsSelector,
  institutionSelector,
  programsSelector,
  setInstitution,
  setInstitutionApplicants,
  setPrograms,
} from "../../store/researchauthoritiesSlice";
import service from "./Helpers/gifservices";
import modules from "./modules/modules";

export default function ResearchAuthorities() {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const institution = useSelector(institutionSelector);
  const institutionApplicants = useSelector(institutionApplicantsSelector);
  const programs = useSelector(programsSelector);

  useEffect(() => {
    if (!!institution) return;
    service.getInstitution().then((institution) => {
      dispatch(setInstitution(institution));
    });
  }, [institution, dispatch]);

  useEffect(() => {
    if (!!institutionApplicants) return;
    const institutionId = institution?.id;
    if (institutionId === null || institutionId === undefined) return;
    service
      .GetInstitutionApplicants({ institutionId })
      .then((institutionApplicants) => {
        dispatch(setInstitutionApplicants(institutionApplicants));
      });
  }, [dispatch, institution?.id, institutionApplicants]);

  useEffect(() => {
    if (!!programs) return;
    service.GetProgramTypes().then((programs) => {
      dispatch(setPrograms(programs));
    });
  }, [dispatch, programs]);

  return (
    <Switch>
      {modules.map(({ path, module: Module }) => (
        <Route
          key={path}
          path={`${match.url}${path}`}
          render={(props) => <Module {...props} baseUrl={match.url} />}
        />
      ))}
      <Redirect to={`${match.url}${modules[0].path}`} />
    </Switch>
  );
}
